import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'flatpickr/dist/themes/material_blue.css';
import { Provider } from 'react-redux';
import { store } from './store'; 
import './utils/flutterBridge'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
     <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);

